import EmergencyContact from '@/models/emegrency-contact'

export const MALE_TITLE = 'mr'
export const FEMALE_TITLES = ['miss', 'mrs', 'ms']
export const MIN_AGE = 17

export default interface Customer {
  id: number
  email: string
  firstName: string
  lastName: string
  fullName: string
  title?: string
  age?: number
  nationality?: string
  tel?: string
  countryCode?: string
  largeAvatarUrl?: string
  thumbAvatarUrl?: string
  isNewAccount: boolean
  passwordResetRequired: boolean
  connectedToFacebook: boolean
  emergencyContact?: EmergencyContact
  isSubscriptionActive?: boolean
  hasActiveBookings: boolean
}
